import React, {useContext} from 'react'
import ModalComponent from '../../../common-scripts/Helpers/ModalComponent'
import {AppContext} from '../Context'
import axios from 'axios'

/**
 * Component that show message when signature is completed
 *
 * @param docusignStatus
 * @param popupCtaInfos
 * @returns {JSX.Element}
 * @constructor
 */
const MessageStatus = ({docusignStatus, popupCtaInfos, datas, dispatchStepEvent}) => {

	let message = '';

	switch (docusignStatus) {
		case 'ds_signed':
			message = `<p> <strong>Vous venez de souscrire au service de Gestion des Volontés ;</strong></p>
      <p> Nous avons bien enregistré vos volontés afin de les transmettre et les faire respecter le jour venu. Vous recevrez dans les prochains jours des étiquettes et cartes d'identification pour vous permettre d'informer vos proches de votre démarche. </p>
         <p>  <strong>Nous vous remercions de votre confiance et restons à votre disposition. </strong>   </p>
              `
			break;

		case 'ds_declined':
			message = `<p> <strong>Vous avez refusé de signer le document</strong></p>  `

			break;

		case 'ds_expired':
			message = `<p> <strong>Votre session a expirée </strong></p>  `
			break;
		case 'ds_cancel':
			if (datas[0].email !== '') {
				dispatchStepEvent('SAVE_AFTER_DOCUSIGN', datas[0].email);
			}
			message = `
				<p> <strong> Votre sauvegarde a bien été prise en compte. </strong> </p>

   				<p>Un email vous a été envoyé comprenant un lien vous permettant de poursuivre votre saisie.</p> `
			break;
	}
	
	const handleButtonClick = () => {
		if (docusignStatus === 'ds_signed') {
		  redirectToUrlMarqueBlanche(popupCtaInfos.link);
		} else {
		  window.location.href = popupCtaInfos.link;
		}
	};
	
	return <>
		<div style={{marginBottom: '15px'}} className="steps_v2 fullwidth tunnel_v2 ">
			<ol className="list-steps el-">
				<li data-idx="7" className="item-5 current   fill-100 ">
					<div className="rounded">
						<div className="circle white">
							<span className="">7/7</span>
						</div>
						<div className="circle grey">
							<div className="segment">
							</div>
						</div>
					</div>
				</li>
			</ol>
		</div>

		<div dangerouslySetInnerHTML={{__html: message}} className="card-body"></div>


		<div className="bottom">
			<div className="prev_next stepper">
				<div id="prev_mobile">
					<button
						onClick={handleButtonClick}
						style={{marginRight: '0px'}}
						className="bouton-picto-left goto_backto "
					>
						{popupCtaInfos.title}
					</button>

				</div>
			</div>
		</div>


	</>
}

/**
 * Async function to redirect Marque blanche url
 * 
 * @async
 * @function
 */
const redirectToUrlMarqueBlanche = async (link) => {
	try {
		const response = await axios.get(link + "/wp-json/gdv/v1/get-url-marque-blanche");
		const urlMarqueBlanche = response.data;
		if (urlMarqueBlanche) {
			window.location.href = urlMarqueBlanche;
		} else {
			console.error("URL marque blanche non définie");
		}
	} catch (error) {
		console.error("Erreur lors de la récupération de l'URL marque blanche :", error);
	}
};

/**
 * Step Signature
 *
 * @returns {JSX.Element}
 * @constructor
 */
const StepSignature = () => {
	const {currentStep, docusignStatus, dispatchStepEvent, popupCtaInfos, datas, setdatas} = useContext(AppContext);

	return (
		<>
			<ModalComponent
				showModal={true}
				content={
					<MessageStatus
						docusignStatus={docusignStatus}
						popupCtaInfos={popupCtaInfos}
						datas={datas}
						dispatchStepEvent={dispatchStepEvent}
					/>
				}
			/>
		</>
	)
}

export default StepSignature;
